<template>
    <div class="add-item-wrapper" @click="itemClick">
        <i class="add-icon"></i>
    </div>
</template>

<script>
export default {
    name: "AddItem",
    methods: {
        itemClick() {
            this.$emit("itemClick");
        }
    }
};
</script>

<style lang="scss" scoped>
.add-item-wrapper {
    width: 200px;
    height: 200px;
    background: #fafbfd;
    border: 1px solid #d8e4f0;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    cursor: pointer;

    .add-icon {
        display: block;
        content: "";
        width: 28px;
        height: 28px;
        background: url($zhijiStaticImagePath+"class-spr.png");
        background-position: -2px -50px;
    }

    &:hover .add-icon {
        background-position: -2px -81px;
    }
}
</style>
